'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationShoppingTabsAccommodationController = function () {
    function WinresReservationShoppingTabsAccommodationController($scope, localizationService, $filter) {
        _classCallCheck(this, WinresReservationShoppingTabsAccommodationController);

        this.$scope = $scope;
        this.$filter = $filter;
        this.localizationService = localizationService;
        this.produtsAreCabins = false;
    }

    _createClass(WinresReservationShoppingTabsAccommodationController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Products
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().NumInfants

            this.data = this.winresReservationContext.getContext();

            this.$scope.$watch(function () {
                return _this.data.Products;
            }, function (products) {
                _this.data.Products.forEach(function (elem, ind) {
                    if (elem.Product.DestinationInfo.ProductType == 'HY') {
                        _this.produtsAreCabins = true;
                    }
                });
                if (_this.type === "all") {
                    _this.HasRoom = _.some(_this.data.Products, function (p) {
                        return (p.Product.DestinationInfo.ProductType == 'HU' || p.Product.DestinationInfo.ProductType == 'HY') && p.Amount > 0;
                    });
                } else {
                    _this.HasRoom = _.some(_this.data.Products, function (p) {
                        return p.Product.DestinationInfo.ProductType == (_this.type || 'HU') && p.Amount > 0;
                    });
                }
            }, true);
        }
    }, {
        key: 'click',
        value: function click() {
            this.winresReservationShoppingTabs.goToPhase('accommodation');
        }
    }, {
        key: 'howManyIsNotAccommodated',
        value: function howManyIsNotAccommodated() {
            this.pplAccomodated = 0;
            if (this.data.Products.length > 0) {
                for (var i = 0; i < this.data.Products.length; i++) {
                    if (this.data.Products[i].Product.DestinationInfo.Accommodation == true) {
                        this.pplAccomodated = this.pplAccomodated + this.data.Products[i].PassengerAssignments.length;
                    }
                }
            }

            if (this.data.NumAdults + this.data.NumChildren + this.data.NumInfants - this.pplAccomodated == 0) {
                if (this.showInfoButton === "true") {
                    return this.$filter('i18next')('winres_departures.modify_accomodation');
                }
                if (this.produtsAreCabins) {
                    return this.$filter('i18next')('reservation_accommodation.choose_cabin');
                } else {
                    return this.$filter('i18next')('reservation_accommodation.choose_accommodation');
                }
            }
            return this.getMissingRoomText(this.data.NumAdults + this.data.NumChildren + this.data.NumInfants - this.pplAccomodated);
        }
    }, {
        key: 'getMissingRoomText',
        value: function getMissingRoomText(numOfPeople) {
            if (this.buttonNText != null) {
                return this.$filter('i18next')(this.buttonNText);
            } else if (this.participantMode === "true") {
                return this.$filter('i18next')('reservation_accommodation.n_is_missing_accommodation', { num: numOfPeople });
            }
            return this.$filter('i18next')('reservation_accommodation.n_is_missing_room', { num: numOfPeople });
        }
    }]);

    return WinresReservationShoppingTabsAccommodationController;
}();

WinresReservationShoppingTabsAccommodationController.$inject = ['$scope', 'localizationService', '$filter'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'shopping-tabs-accommodation';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('shopping-tabs-accommodation', require('./winresReservationShoppingTabsAccommodation.html'));
}]);

_module3.default.component('winresReservationShoppingTabsAccommodation', {
    templateUrl: getTemplate,
    controller: WinresReservationShoppingTabsAccommodationController,
    require: {
        winresReservationContext: '^^winresReservationContext',
        winresReservationShoppingTabs: '^^winresReservationShoppingTabs'
    },
    bindings: {
        emptyText: '@',

        // if type is "all" it searches for HU and HY
        type: '@',
        title: '@',
        showInfoButton: '@',
        participantMode: '@',
        buttonNText: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationShoppingTabsAccommodation/winresReservationShoppingTabsAccommodation.js
// module id = 395
// module chunks = 2